import React, { useState, useEffect } from 'react';
import { Headings } from '../../Pages/RegisteredUsersList/ViewRegList';

const UserTable = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch users from API when the component mounts
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/admin/getAlluser`
        );
        
        if (!response.ok) {
          throw new Error('Failed to fetch users');  
        }
        
        const data = await response.json();

        if (data.status === 1) {
          setUsers(data.users);
        } else {
          throw new Error(data.message || 'Failed to fetch users');
        }
      } catch (error) {
        setError(error.message); 
      } finally {
        setLoading(false); 
      }
    };

    fetchUsers();
  }, []);  

  // Sort users by registration date (most recent first)
  const sortedUsers = [...users].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return dateB - dateA;  
  });
  
  
  const displayedUsers = sortedUsers.slice(0, 10);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="user-table-container">

      <Headings headspan="Recently" hedtext="Added Users" />
      
      <table className="User_Table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Registration Date</th>
          </tr>
        </thead>
        <tbody>
          {displayedUsers.length > 0 ? (
            displayedUsers.map((user,index) => (
              <tr key={user._id}>
              <td>{index + 1}</td>
               <td>{user.fullName}</td>
                <td>{user.email}</td>
                <td>
                  {user.userType === 0
                    ? "Mentee"
                    : user.userType === 1
                    ? "Mentor"
                    : ""}
                </td>
                <td style={{textAlign:"center"}}>{new Date(user.createdAt).toLocaleDateString()}</td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="no-data">
                No users registered
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
